import Const from 'constants';
import {generateSignature, generateRandomKey} from 'helpers/hash';

const stackItemInterface = {
    getId() {
        return this.id;
    },
};

const secondaryStackCombinations = {
    [Const.SECONDARY_STACK_COMBINATION_TYPE_1]: true,
    [Const.SECONDARY_STACK_COMBINATION_TYPE_2]: true,
    [Const.SECONDARY_STACK_COMBINATION_TYPE_3]: true,
    [Const.SECONDARY_STACK_COMBINATION_TYPE_4]: true,
    [Const.SECONDARY_STACK_COMBINATION_TYPE_5]: true,
};

const defaultStateData = {
    stackItems: {},
    secondaryStackCombinations: cp(secondaryStackCombinations),
    useSecondaryStack: false,
    isSecondaryStackForced: true,
    allowOverlapPrimaryAndSecondaryStacks: false,
};

const defaultState = {
    data: cp(defaultStateData),
    enabled: false,
    signature: null,
    all() {
        return {...this.data};
    },
    getItems() {
        return Object.values(this.data.stackItems);
    },
    hasItems() {
        return !isEmpty(this.data.stackItems);
    },
    getItem(itemId) {
        return this.data.stackItems[itemId];
    },
    isEnabled() {
        return Boolean(this.enabled);
    },
    isSecondaryStackUsed() {
        return Boolean(this.data.useSecondaryStack);
    },
    isSecondaryStackForced() {
        return Boolean(this.data.isSecondaryStackForced);
    },
    isOverlapPrimaryAndSecondaryStacksAllowed() {
        return false; // Boolean(this.data.allowOverlapPrimaryAndSecondaryStacks);
    },
    getSecondaryStackCombinations() {
        return {...this.data.secondaryStackCombinations};
    },
    getSignature() {
        return this.signature;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.PLAYER_POSITION_STACKING_SET_DATA_FROM_STORAGE) {
        state.data = action.data;
        Object.keys(state.data.stackItems).map((itemId) => {
            state.data.stackItems[itemId] = {
                ...state.data.stackItems[itemId],
                ...stackItemInterface,
            };
        });
    } else if (action.type === Const.PLAYER_POSITION_STACKING_SET_IS_USED) {
        state.enabled = Boolean(action.use);
    } else if (action.type === Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_USED) {
        state.data.useSecondaryStack = Boolean(action.use);
    } else if (action.type === Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_FORCED) {
        state.data.isSecondaryStackForced = Boolean(action.isChecked);
    } else if (action.type === Const.PLAYER_POSITION_STACKING_SET_ALLOW_OVERLAP_PRIMARY_AND_SECONDARY_STACKS) {
        state.data.allowOverlapPrimaryAndSecondaryStacks = Boolean(action.isChecked);
    } else if (action.type === Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_COMBINATION_TYPE) {
        state.data.secondaryStackCombinations[action.combinationType] = action.value;
    } else if (action.type === Const.PLAYER_POSITION_STACKING_ADD_ITEM) {
        const itemId = generateRandomKey();
        state.data.stackItems[itemId] = {
            ...action.item,
            id: itemId,
            ...stackItemInterface,
        };
    } else if (action.type === Const.PLAYER_POSITION_STACKING_REMOVE_ITEM) {
        delete state.data.stackItems[action.itemId];
    } else if (action.type === Const.CORRELATION_STACKING_SET_IS_USED) {
        Boolean(action.use) && (state.enabled = false);
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: cp(defaultStateData),
            enabled: false,
            signature: generateSignature(),
        };
    }

    return state;
}
